export const isString = (item) => {
  return typeof item === "string" || item instanceof String;
};
